export default {
    items: [
        {
            name: 'Dashboard',
            url: '/admin/dashboard',
            icon: 'fa fa-chart-line',
            badge: {
                variant: 'info',
            }
        },
        {
            name: 'geplante Nachversorgung',
            url: '/admin/scheduledreplenishment',
            icon: 'fa fa-calendar',
            badge: {
                variant: 'info',
            }
        },
        {
            name: 'ausgeführte Nachversorgung',
            url: '/admin/replenishment',
            icon: 'fa fa-truck',
            badge: {
                variant: 'info',
            }
        },
        {
            name: 'Flächensteuerung',
            icon: 'fa fa-project-diagram',
            badge: {
                variant: 'info',
            },
            children: [
                {
                    name: 'Übersicht',
                    url: '/admin/areacontrol/overview',
                    icon: 'fa fa-project-diagram',
                    badge: {
                        variant: 'info',
                    }
                },
                {
                    name: 'Verwaltung',
                    url: '/admin/areacontrol/admin',
                    icon: 'icon-people',
                    badge: {
                        variant: 'info',
                    }
                }
            ]
        },
        {
            name: 'Module',
            icon: 'icon-grid',
            badge: {
                variant: 'info',
            },
            children: [
                {
                    name: 'Modulübersicht',
                    url: '/admin/modules/overview',
                    icon: 'icon-grid',
                    badge: {
                        variant: 'info',
                    }
                },
                {
                    name: 'Modulverwaltung',
                    url: '/admin/modules/admin',
                    icon: 'fa fa-sitemap',
                    badge: {
                        variant: 'info',
                    }
                },
                {
                    name: 'Artikel',
                    url: '/admin/article',
                    icon: 'fa fa-box',
                    badge: {
                        variant: 'info',
                    }
                }
            ]
        },
        {
            name: 'Händlerverwaltung',
            icon: 'icon-people',
            badge: {
                variant: 'info',
            },
            children: [
                {
                    name: 'Händler',
                    url: '/admin/retailer',
                    icon: 'icon-people',
                    badge: {
                        variant: 'info',
                    }
                },
                {
                    name: 'Stores',
                    url: '/admin/retailer/stores',
                    icon: 'fa fa-home',
                    badge: {
                        variant: 'info',
                    }
                },
                {
                    name: 'IPOS-Konfiguration',
                    url: '/admin/retailer/iposconfig',
                    icon: 'fa fa-cogs',
                    badge: {
                        variant: 'info',
                    }
                },
            ]
        },
        {
            name: 'Administration',
            icon: 'fa fa-tools',
            badge: {
                variant: 'info',
            },
            children: [
                {
                    name: 'Benutzer',
                    url: '/admin/admin/user',
                    icon: 'fa fa-user-shield',
                    badge: {
                        variant: 'info',
                    }
                },
                {
                    name: 'Synchronisation',
                    url: '/admin/admin/sync',
                    icon: 'fa fa-sync',
                    badge: {
                        variant: 'info',
                    }
                }
            ]
        },
    ]
};



// WEBPACK FOOTER //
// ./src/admin/components/Sidebar/_nav.js